// SilverZakatTable.js
import React  from 'react';
function SilverZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th > Hasil</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Kewajiban zakat	</td>
          <td>{result.silverZakatDuty === 'yes' ? 'Zakat wajib atas Anda' : 'Zakat tidak wajib atas Anda'}</td>
        </tr>
        <tr >
          <td>Nisab zakat perak</td>
          <td>{result.silverWeightThreshold} (g)  </td>
        </tr>
        <tr >
          <td>Jumlah zakat yang wajib dikeluarkan (dari uang)</td>
          <td>{result.moneyZakatAmount}  </td>
        </tr>
        <tr >
          <td>Jumlah zakat yang wajib dikeluarkan (dari perak)</td>
          <td>{result.silverZakatAmount} (g)  </td>
        </tr>
      </tbody>
    </table>
  );
}
export default SilverZakatTable;